var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/office_building.1138ffdf.png","uri@2x": __webpack_public_path__ + "static/media/office_building.f6f37e76.png","uri@3x": __webpack_public_path__ + "static/media/office_building.ba7956e1.png",
    width: 24,
    height: 24
});